import { render, staticRenderFns } from "./GreetList.vue?vue&type=template&id=05cd1c10"
import script from "./GreetList.vue?vue&type=script&lang=js"
export * from "./GreetList.vue?vue&type=script&lang=js"
import style0 from "./GreetList.vue?vue&type=style&index=0&id=05cd1c10&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports